import { render } from "./ArrowsIn.vue?vue&type=template&id=541a2446"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowsIn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "541a2446"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('541a2446', __exports__)) {
    api.reload('541a2446', __exports__)
  }
  
  module.hot.accept("./ArrowsIn.vue?vue&type=template&id=541a2446", () => {
    api.rerender('541a2446', render)
  })

}


export default __exports__